import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{height:"70vh"}}>
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
